/* eslint-disable react-hooks/exhaustive-deps */
import { ElectricityPackagesService } from "components/ElectricityPackages/ElectricityPackages.service";
import { ELECTRICITY_PACKAGE_METER_TYPES, ElectricityPackageMeterType, ElectricityPackageType, IElectricityPackage } from "components/ElectricityPackages/models";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { ElectricityAgreementForm, INDIVIDUAL_PACKAGE_VALUE } from "../../models";

interface NewElectricityAgreementPackageFormProps {
    form: ElectricityAgreementForm;
    setForm: Dispatch<SetStateAction<ElectricityAgreementForm>>;
    showEnergyPackageForm: boolean;
    isJointInvoicePossible: boolean;
}

export default function NewElectricityAgreementPackageForm(
    { form, setForm, showEnergyPackageForm, isJointInvoicePossible } : NewElectricityAgreementPackageFormProps
) {

    const [consumptionPackages, setConsumptionPackages] = useState<IElectricityPackage[]>([]);
    const [productionPackages, setProductionPackages] = useState<IElectricityPackage[]>([]);

    useEffect(() => {
        getPackages();

        setForm({
            ...form,
            consumptionPackage: {}
        })
    }, [isJointInvoicePossible]);

    const getPackages = () => {
        ElectricityPackagesService.getElectricityPackages({
            page: 0,
            size: 999
        }).then(res => {
            const packagesWithConsumptionType = res.content
                .filter(pckg => pckg.jointInvoicePackage === isJointInvoicePossible)
                .filter(pckg => pckg.type === ElectricityPackageType.CONSUMPTION);
            const packageWithProductionType = res.content.filter(pckg => pckg.type === ElectricityPackageType.PRODUCTION);
            
            setConsumptionPackages(packagesWithConsumptionType);
            setProductionPackages(packageWithProductionType);
        });
    }

    const setPackageValue = (option?: any) => {
        const consumptionPackage = consumptionPackages.find(p => p.id === option?.value);
        const productionPackage = productionPackages.find(p => p.meterType === ElectricityPackageMeterType.QUARTER_HOUR);

        setForm({
            ...form,
            consumptionPackage: {
                id: option?.value === INDIVIDUAL_PACKAGE_VALUE ? INDIVIDUAL_PACKAGE_VALUE : consumptionPackage?.id,
                termsAndConditionsId: consumptionPackage?.terms?.id,
                basePriceCentsKwh: consumptionPackage?.basePriceCentsKwh,
                basePriceTextEt: consumptionPackage?.basePriceTextEt ?? '',
                basePriceTextEn: consumptionPackage?.basePriceTextEn ?? '',
                contractTitle: consumptionPackage?.contractTitle ?? '',
                pdfFooterDisclaimer: (form.isCompany ? consumptionPackage?.pdfFooterDisclaimerCompany : consumptionPackage?.pdfFooterDisclaimerPerson) ?? '',
                monthlyFeeEuros: consumptionPackage?.monthlyFeeEuros,
                earlyTerminationFeeType: consumptionPackage?.earlyTerminationFeeType,
                earlyTerminationFee: consumptionPackage?.earlyTerminationFee,
                marketPricePackage: !!consumptionPackage?.marketPricePackage,
                jointInvoicePackage: !!consumptionPackage?.jointInvoicePackage,
                dynamicPackage: !!consumptionPackage?.dynamicPackage,
                greenEnergy: !!consumptionPackage?.greenEnergy,
                baseFixationType: consumptionPackage?.baseFixationType,
                baseConsumptionProportion: consumptionPackage?.baseConsumptionProportion,
                twoTariffPackage: !!consumptionPackage?.twoTariffPackage,
                dayTariffCentsKwh: consumptionPackage?.dayTariffCentsKwh,
                nightTariffCentsKwh: consumptionPackage?.nightTariffCentsKwh,
                meterType: option?.value === INDIVIDUAL_PACKAGE_VALUE ? ElectricityPackageMeterType.QUARTER_HOUR : consumptionPackage?.meterType
            },
            estimatedConsumptionVolumeMwh: undefined,
            estimatedConsumptionDayVolumeMwh: undefined,
            estimatedConsumptionNightVolumeMwh: undefined,
            productionPackageId: productionPackage?.id,
            endDate: consumptionPackage?.contractEndDate ? new Date(consumptionPackage?.contractEndDate) : form.endDate,
            contractPeriodId: consumptionPackage?.contractPeriod?.id
        })
    }
    const packageOptions = consumptionPackages.map(p => ({ value: p.id, label: p.nameEt }));

    packageOptions.push({ value: INDIVIDUAL_PACKAGE_VALUE, label: 'Individuaalne' });

    const currentPackageOption = packageOptions.find(p => p.value === form.consumptionPackage.id);
    const currentMeterType = ELECTRICITY_PACKAGE_METER_TYPES.find(p => p.value === form.consumptionPackage.meterType);

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Label>{ showEnergyPackageForm ? 'Elektripakett' : 'Pakett'}*</Form.Label>
                        <Select
                            required
                            options={packageOptions}
                            value={currentPackageOption ?? null}
                            onChange={setPackageValue}
                            placeholder='Vali elektripakett'
                            className={'w-100 form-control form-select' + (!form.consumptionPackage.id && form.validated ? ' is-invalid' : '')}
                        />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                { currentPackageOption?.value === INDIVIDUAL_PACKAGE_VALUE ? (
                        <div className="col-12 col-md-6">
                            <Form.Label>Arvesti tüüp*</Form.Label>
                            <Select
                                required
                                options={ELECTRICITY_PACKAGE_METER_TYPES}
                                value={currentMeterType ?? null}
                                placeholder='Vali arvesti tüüp'
                                onChange={(e: any) => setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        meterType: e?.value ?? null
                                    }
                                })}
                                className={'w-100 form-control form-select' + (!form.consumptionPackage?.meterType && form.validated ? ' is-invalid' : '')}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback> 
                        </div>
                    ) : null
                }
            </div>
            { currentPackageOption?.value === INDIVIDUAL_PACKAGE_VALUE ?
                <div className="row mt-3">
                    <div className="col-12 col-md-6">
                        <Form.Label>Paketi eestikeelne nimetus*</Form.Label>
                        <Form.Control
                            required
                            value={form.consumptionPackage.nameEt}
                            onChange={(e: any) => setForm({
                                ...form,
                                consumptionPackage: {
                                    ...form.consumptionPackage,
                                    nameEt: e.target.value
                                }
                            })}
                        />
                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback> 
                    </div>
                    <div className="col-12 col-md-6">
                        <Form.Label>Paketi inglisekeelne nimetus</Form.Label>
                        <Form.Control
                            value={form.consumptionPackage.nameEn}
                            onChange={(e: any) => setForm({
                                ...form,
                                consumptionPackage: {
                                    ...form.consumptionPackage,
                                    nameEn: e.target.value
                                }
                            })}
                        />
                    </div>
                </div> 
                : null
            }
            <div className="row mt-3">
                <div className="col-12 col-md-6">
                    <Form.Check
                        className='form-check-input-no-label'
                        id='market-price-check'
                        label='Börsipakett'
                        checked={form.consumptionPackage.marketPricePackage}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE || form.consumptionPackage.twoTariffPackage || form.consumptionPackage.dynamicPackage}
                        onChange={(e: any) => {
                            if(e.target.checked){
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        marketPricePackage: true,
                                        basePriceCentsKwh: undefined,
                                        basePriceTextEt: !form.consumptionPackage.marketPricePackage ? !form.consumptionPackage.basePriceTextEt ? 'Börsihind + marginaal' : form.consumptionPackage.basePriceTextEt : '',
                                        basePriceTextEn: !form.consumptionPackage.marketPricePackage ? !form.consumptionPackage.basePriceTextEn ? 'Market price + margin' : form.consumptionPackage.basePriceTextEn : ''
                                    }
                                })
                            }else{
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        marketPricePackage: false
                                    }
                                })
                            }
                        }}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='dynamic-package-check'
                        label='Dünaamiline pakett'
                        checked={form.consumptionPackage.dynamicPackage}
                        disabled={true}
                        onChange={(e: any) => {
                            if(e.target.checked){
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        dynamicPackage: true
                                    }
                                })
                            }else{
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        dynamicPackage: false,
                                        basePriceCentsKwh: undefined,
                                        baseFixationType: undefined,
                                        baseConsumptionProportion: undefined
                                    }
                                })
                            }
                        }}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='two-tariff-package-check'
                        label='Kahetariifiline pakett'
                        checked={form.consumptionPackage.twoTariffPackage}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE || form.consumptionPackage.marketPricePackage || form.consumptionPackage.dynamicPackage}
                        onChange={(e: any) => {
                            if(e.target.checked) {
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        twoTariffPackage: true
                                    }
                                })
                            } else {
                                setForm({
                                    ...form,
                                    consumptionPackage: {
                                        ...form.consumptionPackage,
                                        twoTariffPackage: false,
                                        nightTariffCentsKwh: undefined,
                                        dayTariffCentsKwh: undefined,
                                    }
                                })
                            }
                        }}
                        type='checkbox'
                    />
                    <Form.Check
                        className='form-check-input-no-label'
                        id='green-energy-package-check'
                        label='Roheteenus'
                        checked={form.consumptionPackage.greenEnergy}
                        disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE}
                        onChange={(e: any) => setForm({
                            ...form,
                            consumptionPackage: {
                                ...form.consumptionPackage,
                                greenEnergy: e.target.checked
                            }
                        })}
                        type='checkbox'
                    />
                    { form.isJointInvoicePossible && (
                        <Form.Check
                            className='form-check-input-no-label'
                            id='joint-invoice-check'
                            label='Ühisarve'
                            checked={form.consumptionPackage.jointInvoicePackage}
                            disabled={currentPackageOption?.value !== INDIVIDUAL_PACKAGE_VALUE}
                            onChange={(e: any) => setForm({
                                ...form,
                                consumptionPackage: {
                                    ...form.consumptionPackage,
                                    jointInvoicePackage: !form.consumptionPackage.jointInvoicePackage,
                                }
                            })}
                            type='checkbox'
                        />
                    )}
                </div>
            </div>
        </>
    );
}